/**
 * Creates the `playerMemberId` cookie when the URL is `/playerLogin?username=...`.
 *
 * Designed to run as early as possible in the app lifecycle (before Vue/Router/Auth
 * are initialized) so that the cookie is created even when other parts of the app
 * fail to initialize (e.g. missing apiKey/channelKey).
 *
 * Reads from `window.location` directly to avoid any dependency on Vue Router.
 */
export const createPlayerMemberIdCookieFromUrl = () => {
  if (typeof window === 'undefined') return;

  const { pathname, search } = window.location;

  const isPlayerLoginPath = /\/playerLogin\/?$/i.test(pathname);
  if (!isPlayerLoginPath) return;

  const username = new URLSearchParams(search).get('username')?.trim();
  if (!username) return;

  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + 800 * 24 * 60 * 60 * 1000);
  document.cookie = `playerMemberId=${username}; path=/; expires=${expirationDate.toUTCString()};`;
};
